import React from 'react'
import { Skeleton, Flex, ConfigProvider } from 'antd'

const TrendingOfferSkeleton: React.FC = () => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Skeleton: {
                        gradientFromColor: "#404040",
                        gradientToColor: "#606060"
                    },
                },
            }}>
            <div>
                <Flex vertical>
                    <Skeleton.Image active style={{ width: "259px", height: "142px" }} />

                    <Flex className='mt-3' gap={"20px"}>
                        <Skeleton.Avatar active style={{ width: `31px`, height: "31px", marginLeft: "10px" }} shape="circle" />

                        <Flex vertical>
                            <Skeleton.Input active style={{  height: "10px" }} />
                            <Skeleton.Input active style={{height: "10px" }} />
                        </Flex>

                    </Flex>
                </Flex>
            </div>
        </ConfigProvider>
    )
}

export default TrendingOfferSkeleton